/*
路由器对象模块
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

// 声明使用插件
Vue.use(VueRouter)
//pc端路由

const pdfRoutes = [
    {
        path: '/Report',
        name: 'Report',
        component: () => import('@/pages/Report/Report.vue'),
        meta: {
            showHeader: true,
            showFooter: true,
            allowBack: false,
        },
    },
]

const routes = [
    {
        path: '/Report',
        name: 'Report',
        component: () => import('@/pages/Report/Report.vue'),
        meta: {
            showHeader: true,
            showFooter: true,
            allowBack: false,
        },
    },
    {
        path: '/Login',
        component: () => import('@/pages/Login/Login.vue'),
        name: 'Login',
        meta: {
            showHeader: false,
            showFooter: false,
            allowBack: false,
        },
    },
    {
        path: '/',
        redirect: '/Login',
    },
    {
        path: '/Register',
        component: () => import('@/pages/Register/Register.vue'),
        name: 'Register',
        meta: {
            showHeader: false,
            showFooter: false,
            allowBack: false,
        },
    },
    {
        path: '/Reset',
        component: () => import('@/pages/Reset/Reset.vue'),
        name: 'Reset',
        meta: {
            showHeader: false,
            showFooter: false,
            allowBack: false,
        },
    },
    {
        path: '/Select',
        component: () => import('@/pages/Select/Select.vue'),
        name: 'Select',
        meta: {
            showHeader: true,
            showFooter: false,
            allowBack: false,
        },
    },
    {
        path: '/Add',
        name: 'Add',
        component: () => import('@/pages/Add/Add.vue'),
        meta: {
            showHeader: true,
            showFooter: false,
            allowBack: false,
        },
    },
    {
        path: '/Type',
        name: 'Type',
        component: () => import('@/pages/Type/Type.vue'),
        meta: {
            showHeader: true,
            showFooter: true,
            allowBack: false,
        },
    },
    {
        path: '/Question',
        name: 'Question',
        component: () => import('@/pages/Question/Question.vue'),
        meta: {
            showHeader: true,
            showFooter: true,
            allowBack: false,
        },
    },
    {
        path: '/Info',
        name: 'Info',
        component: () => import('@/pages/Info/Info.vue'),
        meta: {
            showHeader: true,
            showFooter: true,
            allowBack: false,
        },
    },
    {
        path: '/Record',
        name: 'Record',
        component: () => import('@/pages/Record/Record.vue'),
        meta: {
            showHeader: true,
            showFooter: true,
            allowBack: false,
        },
    },
    {
        path: '/ipLocation',
        name: 'ipLocation',
        component: () => import('@/pages/ipLocation/ipLocation.vue'),
        meta: {
            showHeader: false,
            showFooter: false,
            allowBack: true,
        },
    },
    {
        path: '/Empty',
        component: () => import('@/pages/Empty/Empty.vue'),
        name: 'Empty',
        meta: {
            showHeader: false,
            showFooter: false,
            allowBack: false,
        },
    },
]

const router = new VueRouter({
    routes: window.config.license === 'pdf' ? pdfRoutes : routes,
})

export default router
